import { useState } from "react";

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const openModal = (message) => { setIsOpen(true); setMessage(message) };
  const closeModal = () => { setIsOpen(false); };
  return { isOpen, openModal, closeModal, message };
};
